module.exports = __webpack_public_path__ + "img/delay.033e9194.svg";